import { ButtonAsA } from 'components/Button/ButtonAsA';
import type { ReactElement } from 'react';
import { isAllIPv4Networks, isAllIPv6Networks } from './isAllNetworks';

const MAX_VISIBLE_COLLAPSED = 3;

const NetworkChip = ({ label }: { label: string }) => (
  <span className='inline-flex rounded-xs border border-solid border-gray-600 bg-transparent p-1 leading-none'>
    {label}
  </span>
);

export const renderNetworks = (
  networks: string[],
  options?: { onShowMore?: () => void; showAll?: boolean },
): ReactElement => {
  const filteredNetworks = networks.filter(
    (network) => network !== '0.0.0.0/0' && network !== '::/0',
  );

  const hasIPv4All = isAllIPv4Networks(networks);
  const hasIPv6All = isAllIPv6Networks(networks);

  const specialLabels: string[] = [];
  if (hasIPv4All) {
    specialLabels.push('All IPv4');
  }
  if (hasIPv6All) {
    specialLabels.push('All IPv6');
  }

  const showAll = options?.showAll ?? false;
  const visibleRegularCount = showAll
    ? filteredNetworks.length
    : Math.max(0, MAX_VISIBLE_COLLAPSED - specialLabels.length);
  const hiddenNetworks = filteredNetworks.slice(visibleRegularCount);

  return (
    <>
      {specialLabels.map((label) => (
        <NetworkChip key={label} label={label} />
      ))}
      {filteredNetworks.slice(0, visibleRegularCount).map((network) => (
        <NetworkChip key={network} label={network} />
      ))}
      {hiddenNetworks.length > 0 && (
        <ButtonAsA
          onClick={options?.onShowMore}
          className='inline-flex self-center text-xs'
        >
          + {hiddenNetworks.length} more
        </ButtonAsA>
      )}
    </>
  );
};
